module.exports = __webpack_public_path__ + "static/media/meddata.f38e6994.svg";